<template>
  <div>
    <p>{{ message }}</p>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

function getUserAgent(): string {
  const navAny = navigator as any;
  const winAny = window as any;

  return navigator.userAgent || navAny.vendor || winAny.opera || "";
}

function isIOS(ua: string): boolean {
  return /iPad|iPhone|iPod/i.test(ua);
}

export default class AuthSuccessful extends Vue {
  message = "Login uspešan. Bićete redirektovani na aplikaciju.";

  mounted(): void {
    // Proverava da li je ovo za promenu lozinke
    const action = this.$route.query.action;
    if (action === "password-changed") {
      this.message = "Lozinka je uspešno promenjena. Bićete redirektovani na aplikaciju.";
    }

    const userAgent = getUserAgent();

    if (isIOS(userAgent)) {
      this.tryCustomScheme(action);
    } else {
      this.tryAndroidIntent(action);

      setTimeout(() => {
        this.tryCustomScheme(action);
      }, 500);
    }
  }

  private tryAndroidIntent = (action: any): void => {
    if (action === "password-changed") {
      window.location.href =
        "intent://retail.soccerbet.rs/password-changed#Intent;scheme=https;package=com.sagastartech.etitoapp.soccerbet.rs.prod;end";
    } else {
      window.location.href =
        "intent://retail.soccerbet.rs/auth-successful#Intent;scheme=https;package=com.sagastartech.etitoapp.soccerbet.rs.prod;end";
    }
  };

  private tryCustomScheme = (action: any): void => {
    if (action === "password-changed") {
      window.location.href = "soccervipclub://password-changed";
    } else {
      window.location.href = "soccervipclub://auth-successful";
    }
  };
}
</script>

<style scoped>
p {
  font-size: 24px;
}
</style>
